// La píldora del NIVEL del cliente. Fuente única: antes cada pantalla se pintaba el suyo.
import { pillClass, type PillSize } from './pillChassis';
import { tierLabel, tierToneClass, type TierLabelMode, type TierValue } from './tierPresentation';

export interface TierPillProps {
    level: TierValue;
    /** `xs` (9.5px) por omisión, la densidad del backoffice; `sm` (11px) es la del wizard. */
    size?: PillSize;
    label?: TierLabelMode;
    /** Presente ⇒ la píldora es un filtro que se prende y se apaga. */
    selected?: boolean;
    onToggle?: () => void;
    disabled?: boolean;
    title?: string;
    className?: string;
}

/**
 * Nivel en pastel, sin punto de color: el relleno ya dice el metal. `null` NUNCA desaparece —se
 * pinta gris con «Sin nivel»—, porque un hueco se dice con palabras.
 */
export function TierPill({
    level,
    size = 'xs',
    label = 'short',
    selected,
    onToggle,
    disabled = false,
    title,
    className,
}: TierPillProps) {
    const off = selected === false;
    const chipClass = pillClass({
        size,
        tone: tierToneClass(level),
        off,
        interactive: onToggle !== undefined,
        className,
    });
    const text = <span className="truncate">{tierLabel(level, label)}</span>;

    if (onToggle === undefined) {
        return (
            <span className={chipClass} title={title}>
                {text}
            </span>
        );
    }

    // `aria-disabled` y no `disabled`: con el atributo nativo el lector de pantalla se salta el
    // control y no anuncia su `title`, así que el corte del click va a mano.
    return (
        <button
            type="button"
            aria-pressed={selected ?? false}
            aria-disabled={disabled || undefined}
            title={title}
            onClick={() => {
                if (disabled) return;
                onToggle();
            }}
            className={chipClass}
        >
            {text}
        </button>
    );
}
